// extracted by mini-css-extract-plugin
module.exports = {"modalButtons":"Modal_modalButtons__1-xUO","buttons":"Modal_buttons__2p3r7","modal":"Modal_modal__2ARsD","close":"Modal_close__3oBlO"};